import { z } from "zod";

import { API_VERSION } from "./common";

export const publicUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.string().nullable(),
  createdAt: z.string(),
  recipeCount: z.number().int().nonnegative(),
});

export const publicUserResponseSchema = z.object({
  apiVersion: z.literal(API_VERSION),
  data: publicUserSchema,
});

export type PublicUserDto = z.infer<typeof publicUserSchema>;
export type PublicUserResponse = z.infer<typeof publicUserResponseSchema>;
